const namespace = {
  title: "Démographie du quartier",
  note: "Affichage des statistiques démographiques pour le quartier.",
  noData:
    "Aucune donnée démographique n'est offerte pour cet endroit particulier.",
  data: {
    income: {
      title: "Revenu",
      graphs: {
        averageIncome: {
          title: "Revenu moyen",
          title_USA: "Revenu médian",
          types: {
            avgHouseholdIncome: "Famille",
            avgHouseholdIncome_USA: "Ménage",
            avgIndividualIncome: "Individuel",
            avgIndividualIncome_USA: "Individuel (par habitant)",
          },
        },
        employment: {
          title: "Emploi",
        },
        incomeBrackets: {
          title: "Tranches de revenu",
        },
      },
    },
    population: {
      title: "Population",
      graphs: {
        totalPopulation: {
          title: "Population totale",
        },
        populationByAgeGroup: {
          title: "Population par tranche d'âge",
        },
      },
    },
    housing: {
      title: "Logement",
      graphs: {
        homeOwnershipType: {
          title: "Propriétaires c.. locataires",
        },
        typeOfHousing: {
          title: "Type de logement",
        },
      },
    },
    household: {
      title: "Ménage",
      graphs: {
        householdComposition: {
          title: "Composition des ménages",
        },
      },
    },
    education: {
      title: "Éducation",
      graphs: {
        educationLevel: {
          title: "Niveau d'études atteint",
        },
      },
    },
    commute: {
      title: "Transport",
      graphs: {
        commuteMode: {
          title: "Mode de déplacement",
        },
      },
    },
    languages: {
      title: "Langues",
      graphs: {
        spokenLanguages: {
          title: "Langues officielles parlées",
        },
        motherTongue: {
          title: "Langue maternelle",
        },
      },
    },
  },
} as const;

export default namespace;
